import React from 'react';
import { Navbar } from '../../components/common/Navbar';
import { Footer } from '../../components/common/Footer';
import { Badge } from '../../components/common/Badge';
import { COMPANY_INFO } from '../../data/siteData';
import { SEO } from '../../components/common/SEO';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-navy">
      <SEO
        title="プライバシーポリシー｜Spaq株式会社"
        description="Spaq株式会社の個人情報保護方針・プライバシーポリシーについてご案内します。"
        canonicalPath="/privacy"
      />
      <Navbar />

      <main className="flex-1">
        <section className="bg-hero-gradient border-b border-surface-border py-12 md:py-16">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
            <Badge variant="cyan" className="mb-4">PRIVACY POLICY</Badge>
            <h1 className="text-3xl sm:text-4xl font-bold text-navy tracking-tight">
              プライバシーポリシー（個人情報保護方針）
            </h1>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl space-y-8 text-sm sm:text-base text-navy-muted leading-relaxed">
            <p>
              {COMPANY_INFO.name}（以下「当社」といいます）は、当社の提供するサービス（電力設計コンサルティング、1minute solar、SPAQ CORE、設備施工等）におけるお客様の個人情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。
            </p>

            <div className="space-y-2">
              <h2 className="text-lg font-bold text-navy">1. 個人情報の取得と利用目的</h2>
              <p>
                当社は、適法かつ公正な手段によって個人情報を取得し、以下の目的の範囲内で利用いたします。
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>お問い合わせ・ご相談への回答および資料送付のため</li>
                <li>太陽光発電・蓄電池・電力制御に関するシミュレーション、設計、施工、保守サービスの提供のため</li>
                <li>協業・パートナー連携に関するご連絡および契約履行のため</li>
                <li>当社サービス・製品・セミナー等のご案内のため</li>
              </ul>
            </div>

            <div className="space-y-2">
              <h2 className="text-lg font-bold text-navy">2. 個人情報の第三者提供</h2>
              <p>
                当社は、法令に定める場合を除き、ご本人の同意を得ることなく個人情報を第三者に提供いたしません。ただし、利用目的の達成に必要な範囲内で、機密保持契約を締結した協力会社・施工パートナー等へ業務を委託する場合があります。
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-lg font-bold text-navy">3. 安全管理措置</h2>
              <p>
                当社は、取り扱う個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-lg font-bold text-navy">4. 開示・訂正・利用停止等のご請求</h2>
              <p>
                ご本人から個人情報の開示、訂正、追加、削除、利用停止等のご請求があった場合には、ご本人確認の上、法令に従い速やかに対応いたします。
              </p>
            </div>

            <div className="rounded-2xl border border-surface-border bg-surface-slate p-6 space-y-1 text-xs sm:text-sm">
              <div className="font-bold text-navy">【個人情報に関するお問い合わせ窓口】</div>
              <div>{COMPANY_INFO.name}</div>
              <div>{COMPANY_INFO.address}</div>
              <div>TEL：{COMPANY_INFO.tel}</div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
